"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[2330],{

/***/ 2330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productLightbox)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7475);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__);



// This component handles the filtration of the PDP popup image slider on variant change
function productLightbox({ wrapper }) {

  const selectors = {
    slider: '.js-image-lightbox',
    closeButton: '.js-video-trigger.video--close-button',
  }

  const cache = {
    $slider: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.slider),
    $closeButton: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.closeButton),
  }

  ;(function init() {
    waitForSlick(jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('sku'))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:change', handleVariantChange)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('lightbox:open', handleLightboxOpen)
    cache.$closeButton.on('click', handleClose)
  })()

  function handleClose() {
    const $lightbox = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)
    $lightbox.hide()
    $lightbox.attr('aria-hidden', 'true')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close')
    document.body.style.overflow = ''
  }

  function handleLightboxOpen(event, { index }) {
    if (cache.$slider.hasClass('slick-initialized')) {
      cache.$slider.slick('slickGoTo', index, true)
    }
    document.body.style.overflow = 'hidden'
  }

  function handleVariantChange(event, { variant }) {
    if (variant && variant.sku) {
      waitForSlick(variant.sku)
    }
  }

  function waitForSlick(sku) {
    const interval = setInterval(function () {
      if (cache.$slider.hasClass('slick-initialized')) {
        clearInterval(interval)
        filterImages(sku)
      }
    }, 100)
  }

  function filterImages(sku) {
    cache.$slider.slick('slickUnfilter')

    // Get all slides
    const allSlides = cache.$slider.find('img').toArray()
    
    // Filter by variant SKU
    const variantSlides = allSlides.filter(slide => {
      let $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slide)
      let colorData = $slide.data('colors')
      return colorData && colorData.includes(sku)
    })

    // Filter lifestyle images (images with 'visible' and 'lifestyle' in data-colors)
    const lifestyleSlides = allSlides.filter(slide => {
      let $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slide)
      let colorData = $slide.data('colors')
      return colorData && colorData.includes('visible') && colorData.includes('lifestyle')
    })

    // Combine variant slides with lifestyle slides
    const combinedSlides = [...variantSlides, ...lifestyleSlides]

    // Apply slick filter to show only the combined slides
    cache.$slider.slick('slickFilter', function (index, slide) {
      let $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(slide).find('img')
      return combinedSlides.includes($slide[0])
    })

    // Initialize slick with proper settings
    if (!cache.$slider.hasClass('slick-initialized')) {
      cache.$slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        adaptiveHeight: true,
        infinite: true
      })
    }

    cache.$slider.slick('slickGoTo', 0, true)

    if (cache.$slider.find('img').length === 0) {
      cache.$slider.slick('slickUnfilter')
    }
  }
}

/***/ })

}]);